import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Partners from './components/Partners';
import Stats from './components/Stats';
import Features from './components/Features';
import Testimonial from './components/Testimonial';
import Footer from './components/Footer';
import ProductEcosystem from './components/ProductEcosystem';
import Stakeholder from './components/Stakeholder';

import './App.css';

function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        document.getElementById(location.state.scrollTo)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [location.state]);

  return (
    <>
      <Hero />
      <section id="who-we-are" className="who-we-are">
        <div className="container">
          <h3 className="who-we-are-subtitle">Smartworks Tech Solution</h3>
          <h2 className="who-we-are-title">One-Stop Technology Solution for Design, Build &amp; Operate</h2>
          <p className="who-we-are-description">
            WorkCtrl is a workspace operations platform that powers the full lifecycle of physical workplaces—from real estate acquisition to daily operations and workplace experience.
          </p>
          <p className="who-we-are-description">
            We help organizations manage buildings, vendors, and operational workflows through a single, connected system. WorkCtrl replaces fragmented tools with a structured platform that brings visibility, control, and consistency across every stage of workspace management.
          </p>
        </div>
      </section>

      <section id="what-makes-different" className="what-makes-different">
        <div className="container">
          <h2 className="section-title">What Makes WorkCtrl Different</h2>
          <p className="section-description">
            WorkCtrl is not a point solution — it is a connected system for workspace operations.
          </p>
          <div className="differentiators-grid">
            <div className="differentiator-card">
              <h3 className="differentiator-title">End-to-End Lifecycle Coverage</h3>
              <p className="differentiator-text">From acquisition to operations to experience</p>
            </div>
            <div className="differentiator-card">
              <h3 className="differentiator-title">Unified Operational Layer</h3>
              <p className="differentiator-text">All building, vendor, and service data in one place</p>
            </div>
            <div className="differentiator-card">
              <h3 className="differentiator-title">Cross-Functional Visibility</h3>
              <p className="differentiator-text">Align real estate, operations, and service teams</p>
            </div>
            <div className="differentiator-card">
              <h3 className="differentiator-title">Structured Execution</h3>
              <p className="differentiator-text">Move from reactive facility management to controlled operations</p>
            </div>
          </div>
        </div>
      </section>

      <section id="built-for" className="built-for">
        <div className="container">
          <h2 className="section-title">Who WorkCtrl Is Built For</h2>
          <p className="section-description">
            WorkCtrl is designed for organizations that manage physical workspaces at scale:
          </p>
          <ul className="built-for-list">
            <li>Enterprises managing multiple office locations</li>
            <li>Real estate and facility management teams</li>
            <li>Co-working and managed workspace operators</li>
            <li>Industrial parks, campuses, and commercial properties</li>
            <li>Organizations focused on workplace experience and operations</li>
          </ul>
          <p className="built-for-closing">
            If your business depends on running efficient, well-managed physical spaces, WorkCtrl provides the system to do it.
          </p>
        </div>
      </section>

      <section id="our-mission" className="our-mission">
        <div className="container">
          <h2 className="section-title">Our Mission</h2>
          <p className="section-description">
            Our mission is to bring structure, visibility, and control to workspace operations by connecting every stage of the workplace lifecycle into a single, unified platform.
          </p>
        </div>
      </section>

      <Partners />
      <Stats />
      <Features />
      <Testimonial />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/product-ecosystem" element={<ProductEcosystem />} />
          <Route path="/stakeholder" element={<Stakeholder />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
